/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionsContainerLocal = {
    readonly dsaFeaturesEnabled: boolean | null;
    readonly " $refType": "ModerationActionsContainerLocal";
};
export type ModerationActionsContainerLocal$data = ModerationActionsContainerLocal;
export type ModerationActionsContainerLocal$key = {
    readonly " $data"?: ModerationActionsContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionsContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dsaFeaturesEnabled",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'c9ab96650634382b62743fa6ddb98619';
export default node;
